export const LIST_PREFERENCES = 'LIST_PREFERENCES';
export const SET_IS_SITEFLOW_USER = 'SET_IS_SITEFLOW_USER';
